/**
 * focusMenuLink moves focus into a mega menu once its first link exists.
 * The mega menu loads deferred, so a keyboard user can open it before its content has rendered:
 * keep trying while the menu is still open and focus hasn't moved away from the trigger.
 * @param {string} linkId - id of the menu link to focus
 * @param {number} timeoutMs - how long to keep waiting for the link to render
 */
export default function focusMenuLink(linkId, timeoutMs = 5000) {
  const trigger = document.activeElement;
  const giveUpAt = Date.now() + timeoutMs;

  const attempt = (isRetry) => {
    // Retries only run while the menu is open and focus is still on its trigger, so a late render can't steal focus
    if (isRetry) {
      const stillOpen = trigger?.getAttribute('aria-expanded') === 'true';
      if (!stillOpen || document.activeElement !== trigger) return;
    }

    const navLink = document.getElementById(linkId);
    if (navLink) {
      navLink.focus();
    } else if (Date.now() < giveUpAt) {
      setTimeout(() => attempt(true), 100);
    }
  };

  // The first attempt matches the original behaviour: focus the link 200ms after opening if it's there
  setTimeout(() => attempt(false), 200);
}
